import { create } from "zustand";
import { persist } from "zustand/middleware";
import { mapBackendRole } from "../config/roles";
import { isTokenExpired } from "../utils/jwt";

export const AUTH_STORAGE_KEY = "auth-storage";

const EMPTY_SESSION = {
  authenticated: false,
  vendorId: null,
  accessToken: null,
  sessionId: null,
  role: null,
  username: "",
  userId: "",
  ship_id: "",
  owner_id: "",
  owner_group_id: "",
  fleet_id: "",
  location: [],
};

const useAuthStore = create(
  persist(
    (set, get) => ({
      ...EMPTY_SESSION,

      login: (
        accessToken,
        userId,
        role,
        username,
        ship_id,
        owner_id,
        owner_group_id,
        fleet_id,
        vendorinfo,
        sessionId,
        location,
      ) => {
        const mappedRole = mapBackendRole(role);
        set({
          authenticated: true,
          accessToken,
          sessionId: sessionId || null,
          role: mappedRole,
          username: username || "",
          ship_id: ship_id || "",
          userId: userId || "",
          owner_id: owner_id || "",
          owner_group_id: owner_group_id || "",
          fleet_id: fleet_id || "",
          vendorId:
            mappedRole === "vendor" ? vendorinfo?.vendor_id || null : null,
          location: location || [],
        });
      },

      logout: () => set({ ...EMPTY_SESSION }),

      // True only when there is a session AND its token is still valid.
      hasValidSession: () => {
        const { authenticated, accessToken } = get();
        return authenticated && !isTokenExpired(accessToken);
      },

      updateProfile: (updates) => set((state) => ({ ...state, ...updates })),
    }),
    {
      name: AUTH_STORAGE_KEY,
      partialize: (state) => ({
        authenticated: state.authenticated,
        vendorId: state.vendorId,
        accessToken: state.accessToken,
        sessionId: state.sessionId,
        role: state.role,
        username: state.username,
        userId: state.userId,
        ship_id: state.ship_id,
        owner_id: state.owner_id,
        owner_group_id: state.owner_group_id,
        fleet_id: state.fleet_id,
        location: state.location,
      }),
    },
  ),
);

// Keep tabs (and sibling apps on this origin) in sync: logging in or out
// anywhere updates the shell without a manual refresh.
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === AUTH_STORAGE_KEY) useAuthStore.persist.rehydrate();
  });
}

export default useAuthStore;
